import type { EventFilters } from "../types/eventFilters";

/** Query object for GET /api/events/ (django-filter). */
export type EventsApiQuery = {
    from_date?: string;
    to_date?: string;
    weekdays?: string;
    event_type?: string;
    min_lat?: string;
    max_lat?: string;
    min_lng?: string;
    max_lng?: string;
};

function endOfDayIso(dateYmd: string): string {
    return `${dateYmd}T23:59:59`;
}

function startOfDayIso(dateYmd: string): string {
    return `${dateYmd}T00:00:00`;
}

export function eventFiltersToApiQuery(filters: EventFilters): EventsApiQuery {
    const q: EventsApiQuery = {};
    if (filters.fromDate) q.from_date = startOfDayIso(filters.fromDate);
    if (filters.toDate) q.to_date = endOfDayIso(filters.toDate);
    if (filters.weekdays.length)
        q.weekdays = filters.weekdays.join(",");
    if (filters.eventTypes.length)
        q.event_type = filters.eventTypes.join(",");
    if (filters.bounds) {
        const b = filters.bounds;
        q.min_lat = String(b.minLat);
        q.max_lat = String(b.maxLat);
        q.min_lng = String(b.minLng);
        q.max_lng = String(b.maxLng);
    }
    return q;
}
